import { Button, theme } from "antd";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { useState } from "react";
const { useToken } = theme;

declare global {
  interface Window {
    google: {
      accounts: {
        id: {
          initialize: (config: GoogleInitializeConfig) => void;
          renderButton: (
            parent: HTMLElement,
            options: GoogleButtonOptions
          ) => void;
          prompt: (
            momentListener?: (res: PromptMomentNotification) => void
          ) => void;
        };
      };
    };
  }
}

interface GoogleInitializeConfig {
  client_id: string;
  callback: (response: CredentialResponse) => void;
  auto_select?: boolean;
  login_uri?: string;
  cancel_on_tap_outside?: boolean;
  prompt_parent_id?: string;
  context?: "signin" | "signup";
}

interface GoogleButtonOptions {
  type?: "standard" | "icon";
  theme?: "outline" | "filled_blue" | "filled_black";
  size?: "small" | "medium" | "large";
  text?: "signin_with" | "signup_with" | "continue_with" | "signin";
  shape?: "rectangular" | "pill" | "circle" | "square";
  logo_alignment?: "left" | "center";
  width?: string;
}

interface CredentialResponse {
  credential: string;
  select_by?: "auto" | "user";
}

interface PromptMomentNotification {
  isDisplayed: () => boolean;
  isSkippedMoment: () => boolean;
  isDismissedMoment: () => boolean;
  getMomentType: () =>
    | "display"
    | "skipped"
    | "dismissed"
    | "interaction_initiated";
}

export function SignInGoogle() {
  // const { setUser } = useAuth();
  const { token } = useToken();
  const [isLogging, setLogging] = useState<boolean>(false);

  return (
    <>
      <Button
        id="google-login-button"
        loading={isLogging}
        onClick={async () => {
          if (isLogging) return;

          setLogging(true);

          try {
            const provider = new GoogleAuthProvider();

            await signInWithPopup(getAuth(), provider);
          } catch (error) {}

          setLogging(false);
        }}
        style={{
          marginBottom: token.marginSM,
          width: "320px",
        }}
      >
        <svg
          width="13"
          height="12"
          viewBox="0 0 13 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.89367 1.60011L8.88106 2.61364C8.22958 2.13539 7.45527 1.89375 6.62085 1.89375C4.82706 1.89375 3.32779 3.10335 2.79197 4.70548L2.79141 4.70719C2.65747 5.11254 2.57866 5.54984 2.57866 6.00313C2.57866 6.45641 2.65747 6.89371 2.79141 7.29906L2.79177 7.30014C3.32592 8.90437 4.82547 10.1141 6.61929 10.1141C7.51483 10.1141 8.29942 9.87734 8.9268 9.4579L9.89367 1.60011ZM9.89367 1.60011C9.00514 0.915004 7.90684 0.507812 6.62085 0.507812C4.47512 0.507812 2.61739 1.73821 1.71293 3.53543C1.34057 4.27737 1.12866 5.11635 1.12866 6.00469C1.12866 6.89286 1.34049 7.73025 1.71289 8.4723C2.61733 10.2696 4.47509 11.5 6.62085 11.5C8.12481 11.5 9.35664 11.0027 10.2471 10.1797L10.2477 10.1792C11.2656 9.24131 11.874 7.84339 11.874 6.13906C11.874 5.89047 11.8602 5.64857 11.8338 5.4125H7.12085V6.73281H9.84585H10.4471L10.3375 7.32397C10.1735 8.20833 9.67335 8.95894 8.92688 9.45784L9.89367 1.60011Z"
            stroke="white"
          />
        </svg>
        Continue with Google
      </Button>
    </>
  );
}
